<template>
  <el-cascader
    :options="ScrapList"
    :show-all-levels="false"
    clearable
    @change="handlerChange"
    placeholder="请选择"
    style="width: 100%"
  >
    <template slot-scope="{ node, data }">
      <span>{{ data.label }}</span>
      <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
    </template>
  </el-cascader>
</template>

<script>
export default {
  props: {
    value: {},
    // ScrapId
    need: {
      type: String,
      default: "ScrapId",
    },
  },
  data() {
    return {
      list: [],
      ScrapList: [],
    };
  },
  mounted() {
    this.$get("VehicleScrap/GetList").then((r) => {
      var id = "ScrapId";
      var parentId = "ParentId";
      let data = JSON.parse(JSON.stringify(r.Result));

      // 生成parent建立父子关系
      const obj = {};
      data.forEach((item) => {
        obj[item[id]] = item;
      });
      const parentList = [];
      const options = [];
      data.forEach((item) => {
        const parent = obj[item[parentId]]; //父节点数据
        if (parent) {
          //  当前项有父节点
          parent.children = parent.children || [];
          parent.children.push({
            value: item[this.need],
            label: item.ScrapName,
          });
        } else {
          //  当前项没有父节点 -> 顶层
          parentList.push(item);
        }
      });
      var c = parentList.map((item) => {
        return {
          value: item[this.need],
          label: item.ScrapName,
          children: item.children,
        };
      });
      this.ScrapList = c;
    });
  },
  watch: {},
  methods: {
    handlerChange(v) {
      this.$emit("input", v);
    },
  },
};
</script>

<style></style>
